// extracted by css-extract-rspack-plugin
export default {"root":"hLfNJ","item":"Zp8hj","itemIcon":"FK5rM","itemLabel":"gOj_d"};